// src/hooks/useServicoGeral.js
import { useState, useEffect } from 'react';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db, paths } from '../firebase/config';
import { useAuth } from '../context/AuthContext';

export const useServicoGeral = () => {
    const { userProfile } = useAuth();
    const [isServicoGeral, setIsServicoGeral] = useState(false);
    const [loadingServico, setLoadingServico] = useState(true);

    useEffect(() => {
        if (!userProfile?.nivel || !['cadete', 'cadete_academico', 'escalante', 'aspirante'].includes(userProfile.nivel)) {
            setIsServicoGeral(false);
            setLoadingServico(false);
            return;
        }

        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        const todayStr = `${yyyy}-${mm}-${dd}`;

        const q = query(
            collection(db, paths.resultado_online), 
            where('cadeteId', '==', userProfile.id),
            where('periodo_fim', '>=', todayStr)
        );

        const unsub = onSnapshot(q, (snap) => {
            let onDuty = false;
            
            // 1. Funções antigas (convertidas para minúsculo)
            const funcoesServicoInterno = [
                "of de dia", "aux of de dia", "al dia eo", "adj de dia", 
                "al dia 1ª cia", "al dia 2ª cia", "al dia 3ª cia", "al dia 4ª cia"
            ];

            // 2. Funções novas (convertidas para minúsculo)
            const funcoesLivres = ["aux cmt cia", "aux cmt pel"];
            
            snap.forEach(doc => {
                const d = doc.data();
                
                // Convertendo tudo para minúsculo para evitar bugs
                const destino = (d.destino || "").toLowerCase();
                const info = (d.informacoes_complementares || "").toLowerCase();
                const detalhes = (d.detalhes || "").toLowerCase(); 
                
                if (d.periodo_inicio <= todayStr) {
                    
                    // Verifica regra do Serviço Interno
                    const regraAntiga = destino === 'serviço interno' && 
                                        (funcoesServicoInterno.includes(info) || funcoesServicoInterno.includes(detalhes));
                    
                    // A CORREÇÃO ESTÁ AQUI: Agora ele também procura as funções novas dentro do campo 'destino'
                    const regraNova = funcoesLivres.includes(destino) || funcoesLivres.includes(info) || funcoesLivres.includes(detalhes);

                    if (regraAntiga || regraNova) {
                        onDuty = true;
                    }
                }
            });

            setIsServicoGeral(onDuty);
            setLoadingServico(false);
        }, (error) => {
            console.error("Erro ao verificar serviço:", error);
            setLoadingServico(false);
        });

        return () => unsub();
    }, [userProfile?.id, userProfile?.nivel]);

    return { isServicoGeral, loadingServico };
};